import { theme, VerticalSpacer, Card as CardComponent } from '@superhi/design'
import { ResponsiveBreakpoint } from '@superhi/design/dist/cjs/theme/media'
import styled from 'styled-components'

export const BlurhashWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  > * {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
  }
`

export const CONTENT_PADDING: Record<ResponsiveBreakpoint, number> = {
  small: 24,
  medium: 40,
  large: 48,
}

export const WRAPPER_PADDING: Record<ResponsiveBreakpoint, number> = {
  small: 52 - CONTENT_PADDING.small,
  medium: 112 - CONTENT_PADDING.medium,
  large: 136 - CONTENT_PADDING.large,
}

export const Wrapper = styled.div`
  position: relative;
  padding: ${WRAPPER_PADDING.small}px 0;

  @media ${theme.breakpoints.medium} {
    padding: ${WRAPPER_PADDING.medium}px 0;
  }

  @media ${theme.breakpoints.large} {
    padding: ${WRAPPER_PADDING.large}px 0;
  }
`

export const Card = styled(CardComponent)``

export const Content = styled(VerticalSpacer).attrs({
  amount: { small: 24, medium: 32, large: 40 },
})`
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: ${theme.colors.WHITE};
  padding: ${CONTENT_PADDING.small}px;
  border-radius: 10px;

  @media ${theme.breakpoints.medium} {
    padding: ${CONTENT_PADDING.medium}px;
  }

  @media ${theme.breakpoints.large} {
    padding: ${CONTENT_PADDING.large}px;
  }
`
